import { Fetch } from 'lib';
import type { CategoryQueryResult } from 'types';

type RequestResponses = {
  categories: CategoryQueryResult[];
};

type RequestParameters = {
  parentId: string;
};

type RequestBody = {
  categoriesIds: string[];
};

const updateOrderOfCategories = async (
  params: RequestParameters,
  body: RequestBody,
) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminCategory/updateOrderOfCategories',
    method: 'PATCH',
    params,
    body,
  });

export { updateOrderOfCategories };
